import { request } from "../lib/http";

export function fetchAll() {
  return request({
    url: "drivergroups",
    method: "get",
  });
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `drivergroup`,
    method: "get",
    params: queriesParams,
  });
}

export function show(id) {
  return request({
    url: `drivergroup/${id}`,
    method: "get",
  });
}

export function add(data) {
  return request({
    url: "drivergroup",
    method: "post",
    data,
  });
}

export function edit(id, data) {
  return request({
    url: `drivergroup/${id}`,
    method: "patch",
    data,
  });
}

export function fetchByCompany(company) {
  return request({
    url: `drivergroups/${company}`,
    method: "get",
  });
}
